module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNiAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgb3BhY2l0eT0iMC4yIj4KPHBhdGggZD0iTTYuNyAxNi4wMzE5TDguMSAxNC4zOTM2TDMuOCA5LjM2MTdIMTZWNy4wMjEyN0gzLjhMOC4xIDEuOTg5MzZMNi43IDAuMzUxMDU5TDAgOC4xOTE0OEw2LjcgMTYuMDMxOVoiIGZpbGw9ImJsYWNrIiBmaWxsLW9wYWNpdHk9IjAuODAyNjkzIi8+CjwvZz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-form-ui/arrow-icon.svg
// module id = HfXt
// module chunks = 46